import { Query } from "../models/query";
export var query = function (fullPath) {
    var _a = String(fullPath).split(/\s*\$\s*/), path = _a[0], subPath = _a[1];
    return new Query(path, subPath);
};
